import { EmployeeRecord } from "./EmployeeRecord";
import { MenuItemRecord } from "./MenuItemRecord";
import { ReportGroup } from "./ReportGroup";
import { SeatRecord } from "./SeatRecord";
import { TimeCard } from "./TimeCard";
import { Void } from "./Void";

export class CheckItemRecord {
	venueKey: number;
	CheckDate: string;
	Key: number;

	SeatKey: number;
	ItemKey: number;

	Position: number;
	RecordNumber: number;
	ID: string;
	Level: number;

	GuestCheckName: string;
	ReportGroupID: number;
	SortKey: string;
	StationID: number;
	OwnerTimeCardID: string;
	OwnerID: number;
	OwnerName: string;
	TimeStamp: string;
	PriceNumber: number;
	Price: number;
	UnitPrice: number;
	Extension: number;
	PriceNumberName: string;
	Qty: number;
	QtyModifiers: number;
	ApprovedBy: string;
	Tax1: boolean;
	Tax2: boolean;
	Tax3: boolean;
	Tax4: boolean;
	Tax5: boolean;
	Tax6: boolean;
	Tax7: boolean;
	Tax8: boolean;
	Tax9: boolean;
	Tax10: boolean;
	Tax11: boolean;
	Tax12: boolean;
	Tax13: boolean;
	Tax14: boolean;
	Tax15: boolean;
	Tax16: boolean;

	FlagModifier: boolean;

	FlagDiscounted: boolean;
	FlagVoided: boolean;
	FlagPrintModifier: boolean;
	FlagIncludeInPrice: boolean;

	FlagKitchenComment: boolean;
	FlagModifierSub: boolean;
	FlagModifierNo: boolean;
	FlagModifierExtra: boolean;

	DiscountAmount: number;
	DiscountInternalID: string;

	TimeVoided: string;
	VoidEmployeeID: number;
	VoidID: number;

	TaxApplied1: string;
	TaxApplied2: string;
	TaxApplied3: string;
	TaxApplied4: string;
	TaxApplied5: string;
	TaxApplied6: string;
	TaxApplied7: string;
	TaxApplied8: string;
	TaxApplied9: string;
	TaxApplied10: string;
	TaxApplied11: string;
	TaxApplied12: string;
	TaxApplied13: string;
	TaxApplied14: string;
	TaxApplied15: string;
	TaxApplied16: string;
	FlagsIncludeInPrice: string;
	FlagsPrintModifier: string;
	FlagsKitchenComment: string;
	FlagsSub: string;
	FlagsNo: string;
	FlagsExtra: string;
	FlagsDiscounted: string;
	FlagsVoid: string;

	Void: Void;

	SeatRecord: SeatRecord;

	MenuItem: MenuItemRecord;

	EmployeeRecord: EmployeeRecord;

	VoidApprover: EmployeeRecord;

	OwnerTimeCard: TimeCard;

	ReportGroup: ReportGroup;

	public constructor(init?: Partial<CheckItemRecord>) {
		Object.assign(this, init);
	}
}
